var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageTarget(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.593,
    height: 28.392,
    viewBox: "0 0 21.593 28.392",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_116",
    "data-name": "Raggruppa 116",
    transform: "translate(1 0.714)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1400",
    "data-name": "Tracciato 1400",
    d: "M14.993,15,10,19.9l4.993,4.9",
    transform: "translate(-2.7 2.16)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1401",
    "data-name": "Tracciato 1401",
    d: "M19.567,8.5a8.446,8.446,0,0,1,0,8.58,8.661,8.661,0,0,1-3.2,3.14A8.86,8.86,0,0,1,12,21.37",
    transform: "translate(-1.144 0.693)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1402",
    "data-name": "Tracciato 1402",
    d: "M10,10.805l4.993-4.9L10,1",
    transform: "translate(-2.7 -1)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_1403",
    "data-name": "Tracciato 1403",
    d: "M6.171,17.87a8.446,8.446,0,0,1,0-8.58,8.66,8.66,0,0,1,3.2-3.14A8.86,8.86,0,0,1,13.737,5",
    transform: "translate(-5 -0.097)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageTarget);
export default __webpack_public_path__ + "static/media/language-target.a3fc2f9cce5114693aa41b36dd0f844a.svg";
export { ForwardRef as ReactComponent };